import { useState, useEffect } from "react";

export default function OFallonHeroSection() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled ? "bg-white shadow-sm border-b border-gray-100" : "bg-transparent"
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between h-[70px]">
          <a href="https://fastpassportcenter.com" className="flex items-center">
            <img
              src="https://staging.fastpassportcenter.com/wp-content/uploads/2026/02/Header.svg"
              alt="Fast Passport Center"
              className={`h-9 w-auto transition-all ${scrolled ? "" : "brightness-0 invert"}`}
            />
          </a>
          <div className="hidden md:flex items-center gap-8">
            {[
              { label: "Services", href: "#services" },
              { label: "How It Works", href: "#how-it-works" },
              { label: "FAQ", href: "#faq" },
            ].map((item) => (
              <a
                key={item.href}
                href={item.href}
                className={`text-sm font-medium transition-colors whitespace-nowrap ${
                  scrolled ? "text-[#1A365D] hover:text-[#F6C344]" : "text-white/90 hover:text-[#F6C344]"
                }`}
              >
                {item.label}
              </a>
            ))}
          </div>
          <div className="flex items-center gap-3">
            <a
              href="tel:8772530084"
              className={`hidden md:inline-flex items-center gap-1.5 text-sm font-semibold transition-colors whitespace-nowrap ${
                scrolled ? "text-[#1A365D] hover:text-[#F6C344]" : "text-white/90 hover:text-[#F6C344]"
              }`}
            >
              <i className="ri-phone-line"></i>877-253-0084
            </a>
            <a
              href="https://fastpassportcenter.com/checkout/"
              className="bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] text-sm font-bold px-5 py-2.5 rounded-md transition-all whitespace-nowrap"
            >
              Get Started
            </a>
            <button
              className="md:hidden flex items-center justify-center w-9 h-9"
              onClick={() => setMobileOpen(!mobileOpen)}
            >
              <i className={`${mobileOpen ? "ri-close-line" : "ri-menu-line"} text-xl ${scrolled ? "text-[#1A365D]" : "text-white"}`}></i>
            </button>
          </div>
        </div>
        {mobileOpen && (
          <div className="md:hidden bg-white border-t border-gray-100 px-4 py-4 space-y-3">
            {[
              { label: "Services", href: "#services" },
              { label: "How It Works", href: "#how-it-works" },
              { label: "FAQ", href: "#faq" },
            ].map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMobileOpen(false)}
                className="block text-sm font-medium text-[#1A365D] hover:text-[#F6C344] py-1"
              >
                {item.label}
              </a>
            ))}
            <a href="tel:8772530084" className="block text-sm font-semibold text-[#1A365D] py-1">
              <i className="ri-phone-line mr-1.5"></i>877-253-0084
            </a>
          </div>
        )}
      </nav>

      <section className="relative min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Scenic%20suburban%20view%20of%20OFallon%20Missouri%20St.%20Charles%20County%20at%20golden%20hour%20with%20modern%20residential%20neighborhoods%2C%20green%20parks%20and%20rolling%20hills%2C%20family-friendly%20community%20atmosphere%2C%20warm%20amber%20sunset%20light%20over%20the%20western%20St.%20Louis%20metro%20area%2C%20well-maintained%20streets%20and%20tree-lined%20boulevards%2C%20peaceful%20Midwestern%20suburban%20landscape%20with%20lush%20vegetation%2C%20professional%20aerial%20photography%20with%20rich%20warm%20colors%20and%20soft%20shadows%2C%20no%20readable%20text%20or%20signs&width=1800&height=700&seq=ofallon-hero-img&orientation=landscape"
          alt="O'Fallon Missouri suburban landscape at golden hour"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/45"></div>
        <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 pt-24 pb-16 text-center">
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-5 leading-tight">
            Emergency &amp; Expedited Passport Services in O&apos;Fallon, MO
          </h1>
          <p className="text-white/80 text-lg md:text-xl max-w-3xl mx-auto mb-8 leading-relaxed">
            O&apos;Fallon is the fastest-growing city in Missouri and one of the largest suburbs in the St. Louis metro. With Scott Air Force Base nearby, military families face frequent deployment and relocation travel. International business through Lambert Airport, European cruises from the Mississippi, and family vacations to Mexico all create urgent passport needs. As a registered U.S. Department of State courier — not a reseller — we offer a best price guarantee and rates typically 30&ndash;100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.
          </p>
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-base px-8 py-4 rounded-md transition-all hover:scale-105 whitespace-nowrap"
          >
            Start My Passport <i className="ri-arrow-right-line"></i>
          </a>

          <div className="mt-10 flex flex-wrap items-center justify-center gap-5 md:gap-8">
            <div className="flex items-center gap-2 text-white/70 text-sm">
              <div className="flex items-center gap-0.5">
                <i className="ri-star-fill text-[#F6C344] text-sm"></i>
                <i className="ri-star-fill text-[#F6C344] text-sm"></i>
                <i className="ri-star-fill text-[#F6C344] text-sm"></i>
                <i className="ri-star-fill text-[#F6C344] text-sm"></i>
                <i className="ri-star-fill text-[#F6C344] text-sm"></i>
              </div>
              <span className="font-semibold">5.0 Reviews</span>
            </div>
            <div className="flex items-center gap-2 text-white/70 text-sm">
              <i className="ri-award-line text-[#F6C344] text-base"></i>
              <span>BBB A+ Accredited</span>
            </div>
            <div className="flex items-center gap-2 text-white/70 text-sm">
              <i className="ri-calendar-check-line text-[#F6C344] text-base"></i>
              <span>20+ Years</span>
            </div>
            <div className="flex items-center gap-2 text-white/70 text-sm">
              <i className="ri-shield-check-line text-[#F6C344] text-base"></i>
              <span>Registered State Dept. Courier</span>
            </div>
            <div className="flex items-center gap-2 text-white/70 text-sm">
              <i className="ri-price-tag-3-line text-[#F6C344] text-base"></i>
              <span>Best Price Guarantee</span>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}